import { render, staticRenderFns } from "./Type16.vue?vue&type=template&id=e3fc21da&scoped=true"
import script from "./Type16.vue?vue&type=script&lang=js"
export * from "./Type16.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3fc21da",
  null
  
)

export default component.exports